import { useState } from 'react'

import clsx from 'clsx'

import { Link } from '@tribeplatform/react-ui-kit/Link'
import { RadioGroup } from '@tribeplatform/react-ui-kit/RadioGroup'
import { equals } from '@tribeplatform/slate-kit/utils'

import { ColorCircle } from '../../../../page-builder/theme-editor/colors-editor/ColorCircle'
import { ColorsPickerList } from '../../../../page-builder/theme-editor/colors-editor/ColorsEditor.component'
import {
  ColorTemplate,
  colorTemplates,
} from '../../../../themes/colors/templates'
import { ActionKind } from '../../../CanaryPageBuilder/types'
import { useThemePreviewContext } from '../ThemePreviewContext'

export const Colors = () => {
  const { state, dispatch } = useThemePreviewContext()
  const [custom, setCustom] = useState<boolean>(false)

  const selectedTemplate = colorTemplates.findIndex(template =>
    equals(template.colors, state.theme.colors),
  )

  return (
    <div className="space-y-5">
      <h4 className="text-basicMain-900">Themes</h4>
      <div className="space-y-3">
        <RadioGroup
          value={`${selectedTemplate}`}
          onChange={idx => {
            dispatch({
              type: ActionKind.SetTheme,
              payload: colorTemplates[idx],
            })
          }}
          variant="stacked-cards"
        >
          <RadioGroup.Items>
            {colorTemplates.map((template, idx) => (
              <RadioGroup.Item key={template.name} value={`${idx}`}>
                {({ checked }) => (
                  <SingleTemplatePicker template={template} checked={checked} />
                )}
              </RadioGroup.Item>
            ))}
          </RadioGroup.Items>
        </RadioGroup>
      </div>

      {custom && (
        <div className="bg-surface-100 rounded-md p-4">
          <ColorsPickerList
            theme={state.theme}
            setThemeUpdates={updates => {
              dispatch({
                type: ActionKind.SetTheme,
                payload: updates(),
              })
            }}
          />
        </div>
      )}
      <div className="flex justify-center">
        {custom ? (
          <Link onClick={() => setCustom(false)} href="#">
            Hide Customization
          </Link>
        ) : (
          <Link onClick={() => setCustom(true)} href="#">
            Customize
          </Link>
        )}
      </div>
    </div>
  )
}

const SingleTemplatePicker = ({
  template,
  checked,
}: {
  template: ColorTemplate
  checked: boolean
}) => (
  <>
    <div className="w-full flex flex-row items-center">
      <div className="flex flex-grow items-center">
        <p>{template.name}</p>
      </div>
      <div className="flex flex-shrink-0 justify-center items-center h-full space-x-1">
        <ColorCircle
          size="md"
          color={template.colors.light.actionPrimary[500]}
        />
        <ColorCircle
          size="md"
          color={template.colors.light.actionSecondary[500]}
        />
        <ColorCircle size="md" color={template.colors.light.main[50]} />
      </div>
    </div>
    <div
      className={clsx(
        checked ? 'border-actionPrimary-500' : 'border-transparent',
        'absolute -inset-px rounded-lg border-2 pointer-events-none',
      )}
      aria-hidden="true"
    />
  </>
)
